import React from 'react';

const SkatingMarkers = () => (
	<g transform="translate(1486.000000, 940.000000)">
		<rect fill="#3B5998" x="8" y="8" width="16" height="16" rx="8"/>
		<g strokeWidth="1" transform="translate(12.000000, 11.000000)" fill="#FFFFFF">
			<path
				d="M7.7451502,7.87598156 C7.7451502,8.15965321 7.51448294,8.39081124 7.2308113,8.39081124 L6.00035782,8.39081124 L6.00035782,7.875 L5.21559838,7.875 L5.21559838,8.39081124 L2.54231214,8.39081124 L2.54231214,7.875 L1.75755269,7.875 L1.75755269,8.39081124 L2.49800181e-15,8.39081124 L2.49800181e-15,9.17557069 L7.2308113,9.17557069 C7.94735213,9.17557069 8.53040042,8.59301318 8.53040042,7.87598156 L7.7451502,7.87598156 Z"
			/>
			<path
				d="M8.12146081,5.42641087 C8.07427373,5.11183031 7.87503937,4.84967984 7.58667386,4.71860461 L7.18296214,4.52985627 L6.64293218,5.50505601 L5.69394749,5.50505601 L6.4279688,4.17333164 L5.74113458,3.85350807 L4.91273911,5.30634595 L3.93753937,5.30634595 L5.08575841,3.3082351 L5.83026574,0.828291693 L2.10055596,-1.14908083e-14 L0.549544819,6.89445348 L8.35215322,6.89445348 L8.12146081,5.42641087 Z"
			/>
		</g>
	</g>
);

export default SkatingMarkers;
